import React, { useState } from 'react';
import styled from 'styled-components';
import { ArrowBack, Close, SaveAltOutlined } from '@material-ui/icons';
import { BLUE, GREY_TEXT } from '../AnalyticsV2.styled';
import { formatDate } from '../utils/status';
import DateRange from '../components/Toolbar/DateRange';
import {
  LinkButton,
  OutlinedButton,
} from '../MessageDetail/MessageDetail.styled';

const TopRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-top: 24px;
`;

const Actions = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

const TitleRow = styled.div`
  display: flex;
  align-items: baseline;
  gap: 16px;
  margin-top: 28px;
`;

const Title = styled.h1`
  margin: 0;
  font-size: 30px;
  font-weight: 400;
  color: #1c1c1c;
  b {
    font-weight: 600;
  }
`;

const ViewLink = styled.button`
  padding: 0;
  border: none;
  background: none;
  font: inherit;
  font-size: 16px;
  color: ${BLUE};
  cursor: pointer;
`;

const Subtitle = styled.div`
  margin-top: 4px;
  font-size: 14px;
  color: ${GREY_TEXT};
`;

// Opens and closes like the info bubble on the Automated Campaigns page.
const ListWrapper = styled.div`
  max-height: ${props => (props.isVisible ? '500px' : '0')};
  opacity: ${props => (props.isVisible ? '1' : '0')};
  margin-top: ${props => (props.isVisible ? '12px' : '0')};
  overflow: hidden;
  transition: max-height 0.3s ease-in, opacity 0.3s ease-in,
    margin-top 0.3s ease-in;
`;

const ListBubble = styled.div`
  display: flex;
  gap: 12px;
  width: 800px;
  max-width: 100%;
  padding: 12px 20px;
  border-radius: 16px;
  background-color: #f8f8f8;
  font-size: 14px;
`;

// Up to MAX_SELECTED messages: the list scrolls inside the bubble.
const List = styled.ul`
  flex: 1;
  max-height: 300px;
  margin: 0;
  padding: 0;
  overflow-y: auto;
  list-style: none;
  color: #212121;
  line-height: 1.5;
`;

const ListItem = styled.li`
  display: flex;
  justify-content: space-between;
  gap: 16px;
  padding: 4px 0;
`;

const SendDate = styled.span`
  flex-shrink: 0;
  color: ${GREY_TEXT};
`;

const CloseButton = styled.button`
  display: flex;
  width: 24px;
  height: 24px;
  padding: 4px;
  border: none;
  border-radius: 4px;
  background: none;
  color: #6c757d;
  cursor: pointer;
  transition: background-color 0.2s;
  &:hover {
    background-color: #e9ecef;
  }
  svg {
    width: 16px;
    height: 16px;
  }
`;

// Back link, the graph's date range, Export CSV, and the heading with the
// number of selected messages and "View", which opens the list of the
// selected messages under the heading.
const Header = ({
  messages,
  dateRange,
  onDateRangeChange,
  disabledDate,
  onCalendarChange,
  onOpenChange,
  onBack,
  onExport,
}) => {
  const [isListOpen, setIsListOpen] = useState(false);

  return (
    <>
      <TopRow>
        <LinkButton onClick={onBack}>
          <ArrowBack /> Back to Messages
        </LinkButton>
        <Actions>
          <DateRange
            value={dateRange}
            onChange={onDateRangeChange}
            disabledDate={disabledDate}
            onCalendarChange={onCalendarChange}
            onOpenChange={onOpenChange}
          />
          <OutlinedButton onClick={onExport}>
            <SaveAltOutlined fontSize="small" /> Export CSV
          </OutlinedButton>
        </Actions>
      </TopRow>
      <TitleRow>
        <Title>
          Combined stats from: <b>{messages.length} selected messages</b>
        </Title>
        <ViewLink onClick={() => setIsListOpen(!isListOpen)}>View</ViewLink>
      </TitleRow>
      <Subtitle>
        Viewing the combined average stats of all selected messages.
      </Subtitle>
      <ListWrapper isVisible={isListOpen}>
        <ListBubble>
          <List>
            {messages.map(message => (
              <ListItem key={message.id}>
                <span>{message.draftName}</span>
                <SendDate>{formatDate(message.sendTime)}</SendDate>
              </ListItem>
            ))}
          </List>
          <CloseButton onClick={() => setIsListOpen(false)}>
            <Close />
          </CloseButton>
        </ListBubble>
      </ListWrapper>
    </>
  );
};

export default Header;
